import { render, staticRenderFns } from "./StatisticsConfigurator.vue?vue&type=template&id=1204c55d&scoped=true&"
import script from "./StatisticsConfigurator.vue?vue&type=script&lang=ts&"
export * from "./StatisticsConfigurator.vue?vue&type=script&lang=ts&"
import style0 from "./StatisticsConfigurator.vue?vue&type=style&index=0&id=1204c55d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1204c55d",
  null
  
)

export default component.exports